/* linguist-generated */
/* eslint-disable */
// Generated code. Do not modify.
// To add additional endpoints, please add them to your api-gateway protos and
// re-run yarn nx run instant-api-hooks-<module>:codegen
//
import { useMemo, useCallback } from 'react';
import { getBaseUrl } from '../../Account-managementApiEnvironment';
import { useMutation, ErrorTypes } from '@cbhq/instant-api-hooks-core/fetch';
import { CONSOLE_PREFIX, CONSOLE_STYLE } from '@cbhq/instant-api-hooks-core/util';

import {
  CoinbaseEngUsersAccountManagementApiApiCancelPendingRoleChangeRequest,
  getCoinbaseEngUsersAccountManagementApiApiCancelPendingRoleChangeRequestErrors,
} from '../../types/coinbase/eng/users/account_management/api/api/CoinbaseEngUsersAccountManagementApiApiCancelPendingRoleChangeRequest';
import {
  CoinbaseEngUsersAccountManagementApiApiCancelPendingRoleChangeResponse,
  getCoinbaseEngUsersAccountManagementApiApiCancelPendingRoleChangeResponseErrors,
} from '../../types/coinbase/eng/users/account_management/api/api/CoinbaseEngUsersAccountManagementApiApiCancelPendingRoleChangeResponse';

type CancelPendingRoleChangeMutationArgs =
  CoinbaseEngUsersAccountManagementApiApiCancelPendingRoleChangeRequest;

export type CancelPendingRoleChangeResult =
  CoinbaseEngUsersAccountManagementApiApiCancelPendingRoleChangeResponse;

const validateCancelPendingRoleChangeResult = (value: unknown) => {
  const errors =
    getCoinbaseEngUsersAccountManagementApiApiCancelPendingRoleChangeResponseErrors(value);
  if (errors.length) {
    console.error(
      CONSOLE_PREFIX,
      CONSOLE_STYLE,
      `API Error: CancelPendingRoleChangeResult data does not match contract.`,
      errors,
    );
  }
};

type HookReturnType = (
  payload: Readonly<CancelPendingRoleChangeMutationArgs>,
  options?: RequestInit,
) => Promise<CancelPendingRoleChangeResult | ErrorTypes>;

export const getCancelPendingRoleChangeUrl = () => {
  const searchParams = new URLSearchParams();
  const url = `${getBaseUrl()}/organization/v1/pending-role-changes/cancel${
    searchParams.toString() === '' ? '' : `?${searchParams}`
  }`;
  return url;
};

/**
 * Post CancelPendingRoleChange
 * @Url /organization/v1/pending-role-changes/cancel
 * @Auth Required
 */
export const useCancelPendingRoleChange = (): HookReturnType => {
  const mutation = useMutation<unknown, CancelPendingRoleChangeResult>();

  const callback = useCallback(
    async (payload: Readonly<CancelPendingRoleChangeMutationArgs>, options?: RequestInit) => {
      const postBody = {
        organization_id: payload.organizationId,
        user_uuid: payload.userUuid,
      };

      const init = { ...(options || {}), method: 'POST' };

      const url = getCancelPendingRoleChangeUrl();
      const result = await mutation(url, postBody, init);
      if (process.env.NODE_ENV !== 'production') {
        validateCancelPendingRoleChangeResult(result);
      }
      return result;
    },
    [mutation],
  );

  return callback;
};
